var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.88 4.779A1.28 1.28 0 0 0 19.705 4H4.294a1.28 1.28 0 0 0-1.176.779 1.35 1.35 0 0 0 .191 1.418l6.119 7.384v5.752c0 .246.13.472.34.588a.63.63 0 0 0 .66-.033l3.856-2.667a.67.67 0 0 0 .286-.554V13.58l6.119-7.383c.329-.4.402-.943.19-1.42"
  })));
};
export default SvgFilter;